<template>
	<div>
		<b-row>
			<b-col lg="12">
				<b-card no-body>
					<b-card-header class="pb-0">
						<b-row>
							<b-col cols="12" xl="8" lg="7" md="7" sm="6" class="d-flex align-items-start">
                <b-button
                  variant="primary"
                  class="mr-5 float-right"
                  size="sm"
                  v-on:click="hideSidebar()"
                  title="Hide Sidebar"
                >
                  <i v-if="$sidebar.isMinimized" class="fas fa-compress"></i>
                  <i v-else class="fas fa-expand"></i>
                </b-button>
								<b-form-group
									label=""
									label-for="per-page-select"
									label-cols-sm="0"
									label-cols-md="0"
									label-cols-lg="0"
									label-align-sm="center"
									label-size="sm"
									class="mb-0 per-page-select"
								>
									<label for="per-page-select" class="mr-2 text-sm mt-1 mr-4">Show</label>
									<b-form-select
										id="per-page-select"
										class="diameter-report-select"
										v-model="perPage"
										:options="pageOptions"
										size="sm"
										v-on:input="changePageOption(perPage)"
									></b-form-select>
								</b-form-group>
							</b-col>
							<b-col cols="12" xl="4" lg="5" md="5" sm="6">
								<b-form-group
									label=""
									label-for="filter-input"
									label-align-sm="right"
									label-size="sm "
									class="mb-0 per-page-select"
								>
									<label for="filter-input" class="text-sm mr-2 mt-1">Search:</label>
									<b-input-group size="sm">
										<b-form-input id="filter-input2" v-model="filter" class="mb-4"></b-form-input>
									</b-input-group>
								</b-form-group>
							</b-col>
						</b-row>
					</b-card-header>
					<b-card-body class="p-3">
						<span>
							<!--              head-variant="light"-->
							<!--              table-class="text-nowrap"-->
							<!--              class="data-management-table primary-table"-->
							<!--              sticky-header="true"-->
							<!--              thead-class="white"-->
							<!--                  class="text-center diameter-report-table overwatch"-->

							<b-table
								striped
								hover
								id="overwatch-search-results"
								sticky-header="true"
								:items="items"
								:fields="fields"
								:current-page="currentPage"
								:per-page="perPage"
								:filter="filter"
								:filter-included-fields="filterOn"
								:sort-by.sync="sortBy"
								:sort-desc.sync="sortDesc"
								:sort-direction="sortDirection"
								class="text-center data-management-table primary-table overwatch"
								show-empty
								responsive
								small
								@filtered="onFiltered"
							>
								<template #cell(actions)="row">
									<div @contextmenu.prevent="onContextMenu" v-on:mousedown="gettrData(row.item)">
										<span class="text-success cursor-pointer pr-2" v-b-tooltip.hover title="Detail">
											<img
                        data-cy="overwatch-result-detail"
												:src="detailsPng"
												alt="details png"
												v-on:click="
                          $bvModal.show('details-view-modal');
                          getDetailsData(
                            row.item.pcapfile_id,
                            row.item.frame_num,
                            row.item.standard_id,
                            true
                          );
												"
											/>
										</span>
										<span
											class="text-danger cursor-pointer pr-2"
											v-b-tooltip.hover
											title="Download"
											v-on:click="getSavedData(row.item.pcapfile_id, row.item.standard_id)"
										>
											<img :src="savePng" alt="save png" />
										</span>
										<span
                      v-if="row.item.relatedTitle"
                      data-cy="overwatch-result-related"
											class="text-danger cursor-pointer"
											v-b-tooltip.hover
											title="Related"
											v-on:click="
                        $bvModal.show('related-details-view-modal');
												getRelatedData(
													row.item.pcapfile_id,
													row.item.frame_num,
													row.item.standard_id,
													row.item.relatedTitle,
													true
												)
											"
										>
											<img :src="relatedPng" alt="related png" />
										</span>
									</div>
								</template>
								<template #cell(frame_dt)="row">
									<div @contextmenu.prevent="onContextMenu" v-on:mousedown="gettrData(row.item)">
										<span class="textnowrap">{{ row.item.frame_dt }}</span>
									</div>
								</template>
								<template #cell(calling)="row">
									<div @contextmenu.prevent="onContextMenu" v-on:mousedown="gettrData(row.item)">
										<span>{{ row.item.calling }}</span>
									</div>
								</template>
								<template #cell(called)="row">
									<div @contextmenu.prevent="onContextMenu" v-on:mousedown="gettrData(row.item)">
										<span>{{ row.item.called }}</span>
									</div>
								</template>
								<template #cell(src_tid)="row">
									<div @contextmenu.prevent="onContextMenu" v-on:mousedown="gettrData(row.item)">
										<span>{{ row.item.src_tid }}</span>
									</div>
								</template>
								<template #cell(imsi)="row">
									<div @contextmenu.prevent="onContextMenu" v-on:mousedown="gettrData(row.item)">
										<span>{{ row.item.imsi }}</span>
									</div>
								</template>
								<template #cell(dest_tid)="row">
									<div @contextmenu.prevent="onContextMenu" v-on:mousedown="gettrData(row.item)">
										<span>{{ row.item.dest_tid }}</span>
									</div>
								</template>
								<template #cell(opc)="row">
									<div @contextmenu.prevent="onContextMenu" v-on:mousedown="gettrData(row.item)">
										<span>{{ row.item.opc }}</span>
									</div>
								</template>
								<template #cell(dpc)="row">
									<div @contextmenu.prevent="onContextMenu" v-on:mousedown="gettrData(row.item)">
										<span>{{ row.item.dpc }}</span>
									</div>
								</template>
								<template #cell(component)="row">
									<div @contextmenu.prevent="onContextMenu" v-on:mousedown="gettrData(row.item)">
										<span>{{ row.item.component }}</span>
									</div>
								</template>
								<template #cell(ctx_name)="row">
									<div @contextmenu.prevent="onContextMenu" v-on:mousedown="gettrData(row.item)">
										<span>{{ row.item.ctx_name }}</span>
									</div>
								</template>
								<template #cell(result_name)="row">
									<div @contextmenu.prevent="onContextMenu" v-on:mousedown="gettrData(row.item)">
										<span>{{ row.item.result_name }}</span>
									</div>
								</template>
								<template #cell(std)="row">
									<div @contextmenu.prevent="onContextMenu" v-on:mousedown="gettrData(row.item)">
										<span>{{ row.item.std }}</span>
									</div>
								</template>
                <template #empty="scope">
                  <div v-if="isLoading" class="text-center">
                    <b-icon icon="three-dots" animation="cylon" font-scale="4" />
                  </div>
                  <div v-else class="text-center">
                    <b>{{ scope.emptyText }}</b>
                  </div>
                </template>
							</b-table>
							<b-row v-if="items.length > 0" class="mt-4">
								<b-col>
									<p class="ml-3 nowrap">{{ startPage() }} - {{ lastPage() }} of {{ totalRows }}</p>
								</b-col>
								<b-col>
									<b-pagination
										class="flex-fill-custom pr-4 ml-3 justify-content-end"
										v-model="currentPage"
										:total-rows="totalRows"
										:per-page="perPage"
										size="sm"
									></b-pagination>
								</b-col>
							</b-row>
						</span>
					</b-card-body>
				</b-card>
			</b-col>
		</b-row>

		<b-modal
      data-cy="overwatch-result-related-modal"
			id="related-details-view-modal"
			title="Related Details"
			size="xl"
      centered
      ok-only
			@ok="closeTree()"
		>
			<b-container class="text-center">
				<b-row id="element">
					<b-col cols="6">
						<b-icon
              v-if="relatedDataLoading"
							icon="arrow-clockwise"
							animation="spin"
							font-scale="1"
						></b-icon>
						<div v-if="!relatedDataLoading" class="overWatch-detail">
							<span class="h4">{{ jTreeTitle }}</span>
							<v-tree :scope-data="jTreeData">
								<ul slot-scope="menuLevel">
									<li v-for="(menuItem, index) in menuLevel" :key="index">
										<a
											@click="menuItem.event ? getDetailsData(menuItem.event) : ''"
											v-bind:class="menuItem.event ? 'cursor-pointer text-primary' : ''"
											>{{ menuItem.title }}</a
										>
										<v-tree v-if="menuItem.children" :scope-data="menuItem.children"></v-tree>
									</li>
								</ul>
							</v-tree>
						</div>
					</b-col>
					<b-col xl="6" md="6" sm="6">
						<b-icon
							icon="arrow-clockwise"
							animation="spin"
							font-scale="1"
							v-if="detailedLoadingStatus"
						></b-icon>
						<span v-if="jsTreeData.length > 0">
							<v-jstree
								class="overWatch-detail"
								v-if="!detailedLoadingStatus"
								:data="jsTreeData"
								multiple
								allow-batch
								whole-row
								@item-click="jsTreeClickEvent"
							>
							</v-jstree>
						</span>
					</b-col>
				</b-row>
			</b-container>
		</b-modal>

		<b-modal
      data-cy="overwatch-result-detail-modal"
			id="details-view-modal"
			title="Details"
			size="xl"
      centered
      ok-only
			@ok="closeTree()"
		>
			<b-card class="text-center">
        <b-icon
          v-if="detailedLoadingStatus"
          icon="arrow-clockwise"
          animation="spin"
          font-scale="1"
        ></b-icon>
        <span v-if="jsTreeData.length > 0">
          <v-jstree
            class="overWatch-detail"
            v-if="!detailedLoadingStatus"
            :data="jsTreeData"
            multiple
            allow-batch
            whole-row
            @item-click="jsTreeClickEvent"
          >
          </v-jstree>
        </span>
			</b-card>
		</b-modal>
	</div>
</template>

<script>
import detailsPng from "../../../../../public/details.png";
import savePng from "../../../../../public/save.png";
import relatedPng from "../../../../../public/related.png";
import overwatchService from "../../../../common/api-services/overwatch-service";
import VJstree from "vue-jstree";
import VTree from "vue-vtree";
import swal from "sweetalert2";
import pagination from "../../../../common/format/pagination";

export default {
	name: "Overwatch-Result",
	components: {
		VJstree,
		VTree,
	},
	data() {
		return {
			items: [],
			fields: [
				{key: "actions", label: "Action"},
				{key: "frame_dt", label: "Date/Time", sortable: true, sortDirection: "desc"},
				{key: "calling", label: "Calling", sortable: true, sortDirection: "desc"},
				{key: "called", label: "Called", sortable: true, sortDirection: "desc"},
				{key: "src_tid", label: "Src TID", sortable: true, sortDirection: "desc"},
				{key: "imsi", label: "IMSI", sortable: true, sortDirection: "desc"},
				{key: "dest_tid", label: "Dest TID", sortable: true, sortDirection: "desc"},
				{key: "opc", label: "OPC", sortable: true, sortDirection: "desc"},
				{key: "dpc", label: "DPC", sortable: true, sortDirection: "desc"},
				{key: "component", label: "Component", sortable: true, sortDirection: "desc"},
				{key: "ctx_name", label: "Op Code", sortable: true, sortDirection: "desc"},
				{key: "result_name", label: "Result", sortable: true, sortDirection: "desc"},
				{key: "std", label: "Std", sortable: true, sortDirection: "desc"},
			],
			sortBy: "",
			sortDesc: false,
			sortDirection: "asc",
			detailsPng: detailsPng,
			savePng: savePng,
			relatedPng: relatedPng,
			jTreeData: [],
			jTreeTitle: null,
			relatedDataLoading: false,
			jsTreeData: [],
			detailedLoadingStatus: false,
			showContextMenu: false,
			selectedData: {},

      isLoading: false,
			totalRows: 0,
			currentPage: 1,
			perPage: 10,
			fromPage: 10,
			pageOptions: [10, 25, 50, 100],
			filter: null,
			filterOn: [],
		};
	},
	mounted() {
    this.$root.$on("overwatch-loading", res => {
      this.isLoading = res;
      if (res) {
        this.items = [];
        this.totalRows = 0;
      }
    });

		this.$root.$on("renderOverwatchTableData", res => {
			//console.log('results: ',res);
			this.totalRows = res.length;
			this.items = res;
			this.jsTreeData = [];
			this.jTreeData = [];
      this.isLoading = false;
			document.getElementById("overwatch-search-results").scrollIntoView({
				behavior: "smooth",
			});
		});

		this.$root.$on("emitShowDetails", res => {
			this.getDetailsData(res.data.pcapfile_id, res.data.frame_num, res.data.standard_id);
		});

		this.$root.$on("emitShowRelated", res => {
			this.getRelatedData(res.data.pcapfile_id, res.data.frame_num, res.data.standard_id, res.data.relatedTitle);
		});

		this.$root.$on("clearOverwatchResult", () => {
			this.items = [];
		});
	},
	methods: {
		getDetailsData(pcapFileId, frameNum, standardId, createLog = false) {
			let historyData = {
				action: "ShowDetails",
				data: {
					pcapfile_id: pcapFileId,
					frame_num: frameNum,
					standard_id: standardId,
				},
			};

			if (createLog) {
				this.$root.$emit("actionHistorySave", historyData);
			}

			this.detailedLoadingStatus = true;
			overwatchService.getOverwatchDetails(pcapFileId, frameNum, standardId).then(res => {
				this.detailedLoadingStatus = false;
				let stringItem = JSON.stringify(res);
				stringItem = stringItem.replaceAll("child", "children");
				stringItem = stringItem.replaceAll("name", "text");
				stringItem = stringItem.replaceAll('"text"', '"opened":"true","text"');
				this.jsTreeData = JSON.parse(stringItem);
        // console.log(this.jsTreeData.title);
			});
		},

		getSavedData(pcapFileId, standardId) {
			this.$toast.info("This is downloading now", {timeout: 4500});
			overwatchService.getDownloadDetails(pcapFileId, standardId).then(res => {
				return overwatchService.downloadItem(res.link, res.filename)
          .then((res) => {
            if (String(res).toLowerCase().includes("error")) {
              this.$toast.error("Download Failed", {timeout: 4500});
            } else {
              this.$toast.success("Downloaded Successfully", {timeout: 4500});
            }
          })
          .catch(() => {
            this.$toast.error("Download Failed", {timeout: 4500});
          });
			});
		},

		getRelatedData(pcapFileId, frameNum, standardId, relatedTitle, createLog = false) {
			let historyData = {
				action: "ShowDetails",
				data: {
					method: relatedTitle,
					pcapfile_id: pcapFileId,
					frame_num: frameNum,
					standard_id: standardId,
				},
			};
			if (createLog) {
				this.$root.$emit("actionHistorySave", historyData);
			}
			this.relatedDataLoading = true;
			overwatchService.getRelatedDataDetails(pcapFileId, frameNum, standardId, relatedTitle).then(res => {
				this.relatedDataLoading = false;
        // console.log(res);
				this.jTreeTitle = res.title;
				let jTreeData = res.data;
				jTreeData.map(item => {
					if (item.event) {
						item.event = item.event.split("(")[1].split(")")[0];
					}
				});
				let stringItem = JSON.stringify(jTreeData);
				stringItem = stringItem.replaceAll("child", "children");
				stringItem = stringItem.replaceAll("name", "title");
				this.jTreeData = JSON.parse(stringItem);
			});

			this.getDetailsData(pcapFileId, frameNum, standardId);
		},

		jsTreeClickEvent(node) {
			// console.log(node.model.text + ' clicked !')
		},

		gettrData(trData) {
			this.selectedData = {
				pcapFileId: trData.pcapfile_id,
				frameNum: trData.frame_num,
				standardId: trData.standard_id,
				relatedTitle: trData.relatedTitle ? trData.relatedTitle : undefined,
				imsi: trData.imsi,
				tId: trData.src_tid,
			};
		},

		onContextMenu(event) {
			this.$contextmenu({
				items: [
					{
						label: "Show Details",
						onClick: () => {
							this.getDetailsData(
								this.selectedData.pcapFileId,
								this.selectedData.frameNum,
								this.selectedData.standardId,
								true
							);
						},
					},
					{
						label: "Download",
						onClick: () => {
							this.getSavedData(this.selectedData.pcapFileId, this.selectedData.standardId);
						},
					},
					{
						label: "Show Related",
						onClick: () => {
							if (this.selectedData.relatedTitle) {
								this.getRelatedData(
									this.selectedData.pcapFileId,
									this.selectedData.frameNum,
									this.selectedData.standardId,
									this.selectedData.relatedTitle,
									true
								);
							} else {
								swal.fire({
									title: "Warning",
									text: `No Related Found!`,
									type: "success",
									customClass: {
										confirmButton: "btn btn-danger",
									},
									buttonsStyling: false,
								});
							}
						},
					},
					{
						label: "Lookup IMSI",
						onClick: () => {
							setTimeout(() => {
								this.$root.$emit("lookupIMSIFunc", this.selectedData.imsi);
							}, 1000);
						},
					},
					{
						label: "Lookup Scr TID",
						onClick: () => {
							setTimeout(() => {
								this.$root.$emit("lookupSrcTIdFunc", this.selectedData.tId);
							}, 1000);
						},
					},
				],
				event,
				customClass: "class-a",
				zIndex: 3,
				minWidth: 150,
			});
			return false;
		},

		revertAction() {
			let status = false;
			setTimeout(() => {
				this.$root.$emit("revertActionFunc", status);
			}, 400);
		},

		closeTree() {
			this.jsTreeData = [];
			this.jTreeData = [];
		},

    hideSidebar() {
      // console.log("hideSidebarFunc");
      this.$sidebar.toggleMinimize()
    },

		getTotalRows() {
			if (this.perPage > this.totalRows) {
				this.fromPage = this.totalRows;
			} else {
				this.fromPage = this.perPage;
			}
		},

		changePageOption(page) {
			this.getTotalRows();
		},

		startPage() {
			return pagination.startPageFunc(this.currentPage, this.perPage);
		},

		lastPage() {
			return pagination.lastPageFunc(this.currentPage, this.perPage, this.totalRows);
		},

		onFiltered(filteredItems) {
			this.totalRows = filteredItems.length;
			this.currentPage = 1;
		},
	},
};
</script>
<style scoped>
/*Fix the control disabled text color*/
.form-control {
	color: #000000ff !important;
}
</style>
